export enum ACTION_TYPES {
  TOGGLE_TOUR_VISIBILITY  = "TOGGLE_TOUR_VISIBILITY",
  //add here
}
